import Vue from 'vue'
import Vuex from 'vuex'
import sample from './sample'
import action from './action'
import domain from './domain'
import frame from './frame'
import decisiontree from './decisiontree'
import signin from './signin'
import account from './account'

Vue.use(Vuex)

// const debug = process.env.NODE_ENV !== 'production'

const store = new Vuex.Store({
  modules: {
    sample,
    action,
    domain,
    frame,
    decisiontree,
    signin,
    account
  },
  plugins: []
})

export default store



// WEBPACK FOOTER //
// ./src/stores/index.js